import { Grid, Skeleton } from '@mui/material'

const AddEditCertificateFormSkeleton = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Skeleton variant='rounded' width={400} height={300} />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant='rounded' height={48} />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant='rounded' height={48} />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant='rounded' height={48} />
      </Grid>
      <Grid item xs={6}>
        <Skeleton variant='rounded' height={48} />
      </Grid>
      <Grid item xs={6}>
        <Skeleton variant='rounded' height={48} />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant='rounded' height={48} />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant='rounded' height={170} />
      </Grid>
    </Grid>
  )
}

export default AddEditCertificateFormSkeleton
